import {
    Directive,
    ElementRef,
    Input,
    SimpleChanges,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    EventEmitter
} from "@angular/core";
import { VgAPI } from "../../core/services/vg-api";
import { IHLSConfig } from './hls-config';
import { Subscription } from 'rxjs';
import { BitrateOption, VgUtils } from '../../core/core';
import { StorageService } from "../../../../storageprovider";
import { UserService } from "../../../../_service/user/user.service";
import { Utility } from "../../../../_service/utility";

declare let Hls;

@Directive({
    selector: '[vgHls]',
    exportAs: 'vgHls'
})
export class VgHLS implements OnInit, OnChanges, OnDestroy {
    @Input() vgHls: string;
    @Output() onHlsError: EventEmitter<any> = new EventEmitter();
    @Output() onGetBitrates: EventEmitter<{ levels: BitrateOption[], startLevel: any }> = new EventEmitter();
    @Output() onLevelChanged: EventEmitter<number> = new EventEmitter();

    get defaultSharpnes() {
        return this.storage.GetConfig()["sharpness"];
    };
    vgFor: string;
    target: any;
    hls: any;
    preload: boolean;
    crossorigin: string;
    config: IHLSConfig;

    subscriptions: Subscription[] = [];

    constructor(
        private ref: ElementRef,
        public API: VgAPI,
        private storage: StorageService,
        private user: UserService,
        private _utility: Utility
    ) { }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        } else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
    }

    isHlsSupport() {

        try {
            if ((VgUtils.isiOSDevice()
                || VgUtils.IsMac()) && VgUtils.isSafari()) {
                return false;
            }
            if (Hls.isSupported()) {
                return true;
            }
        }
        catch
        {

        }

        return false;
    }

    onPlayerReady() {

        this.crossorigin = this.ref.nativeElement.getAttribute('crossorigin');
        this.preload = this.ref.nativeElement.getAttribute('preload') !== 'none';
        this.vgFor = this.ref.nativeElement.getAttribute('vgFor');
        this.target = this.API.getMediaById(this.vgFor);

        this.config = <IHLSConfig>{
            autoStartLoad: this.preload,
            levelLoadingMaxRetry: 2,
            enableWorker: true,
            backBufferLength: 90,
            lowLatencyMode: true
        };

        if (this.crossorigin === 'use-credentials') {
            this.config.xhrSetup = (xhr, url) => {
                xhr.withCredentials = true;
            };
        }

        this.createPlayer();

    }

    ngOnChanges(changes: SimpleChanges) {
        //console.log(Object.assign({},changes));
        if (changes['vgHls'] && changes['vgHls'].currentValue) {
            if (!!changes['vgHls'].previousValue)
                this.createPlayer();
        }
        else {
            this.destroyPlayer();
        }
    }

    private shouldUseHlsmin() {

        var ext = this.getFileExtensions(this.vgHls);
        if (this.vgHls && ext != 'mp4'
            && ext != 'js'
        ) {
            return this.isHlsSupport();

        }
        return false;

    }


    getFileExtensions(url) {
        try {
            url = url.split("#")[0].split("?")[0];
            return url.substring(url.lastIndexOf('.') + 1, url.length) || url;
        } catch (error) {
            return ""
        }


    }

    // mediaErrorHandleTimeout = null;
    // shouldSwitchAudioError = false;
    createPlayer() {

        if (this.hls) {
            this.destroyPlayer();
        }

        if(this.isDestorying)
        {
            return;
        }
        // It's a HLS source
        if (this.shouldUseHlsmin()) {

            console.debug("load hls")
            let video: HTMLVideoElement = this.ref.nativeElement;
            var shouldPlaySecond = this._utility.preLoadPlaySecond?.start || 0;//this.ref.nativeElement.getAttribute('data-shouldPlay');
            if (shouldPlaySecond) {
                shouldPlaySecond = shouldPlaySecond;
                this._utility.preLoadPlaySecond = null;
            }
            else {
                shouldPlaySecond = 0;
            }
            if (this.target && !!this.target.pause) { /* stop previou media */

                this.target.pause();
                try {
                    video.attributes["src"] = "";
                }
                catch (err) {

                }
            }

            this.hls = new Hls(Object.assign({ startPosition: shouldPlaySecond }, this.config));
            this.hls.on(
                Hls.Events.MANIFEST_PARSED,
                (event, data) => {
                    //console.log(this.defaultSharpness);
                    const currentPlayTitle = this.defaultSharpnes || "720";
                    const dl = data.levels.findIndex(l => l.name === currentPlayTitle);
                    const defaultLevel = dl > -1 ? dl : undefined;
                    let selectedLevel = -1;
                    var videoList = [];
                    if (this.hls.levels.length > 1) {
                        selectedLevel = defaultLevel != undefined ? defaultLevel : this.user.user.id == 0 || this.user.user.token.gid == 0 ? 0 : data.levels.length - 1;
                        if (selectedLevel > -1)
                            this.hls.nextLevel = selectedLevel;
                    }
                    //console.log(dl)
                    data.levels.forEach((item, index) => {
                        item.url.forEach((u, i) => {
                            videoList.push({
                                qualityIndex: index + i,
                                width: item.width,
                                height: item.height,
                                bitrate: item.bitrate,
                                mediaType: 'video',
                                label: item.name,
                            });
                        });
                    });
                    //console.log(this.hls.nextLevel,defaultLevel,selectedLevel)
                    if (selectedLevel > -1) {
                        this.onGetBitrates.emit({ levels: videoList, startLevel: videoList[selectedLevel] });
                    }
                }
            );

            this.hls.on(Hls.Events.ERROR, (event, data) => {
                if (data.fatal) {
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            // try to recover network error
                            console.debug('fatal network error encountered, try to recover');
                            this.onHlsError.emit(data);
                            //this.hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            console.debug('fatal media error encountered, try to recover, try jump to next chunk');
                            this.API.seekTime(this.API.getDefaultMedia().currentTime + 1);
                            //this.hls.recoverMediaError();
                            break;
                        default:
                            // cannot recover
                            this.onHlsError.emit(data);
                            break;
                    }
                }

            });

            this.hls.on(Hls.Events.LEVEL_SWITCHED, (event, data) => {
                this.onLevelChanged.emit(data.level);
            })


            this.hls.loadSource(this.vgHls);
            this.hls.attachMedia(video);
            this.API.ss = this;
            //  console.log("auto level enable",this.hls.autoLevelEnabled)
        }
        else {

            if (this.target && !!this.target.pause) {
                this.target.pause();
                this.target.seekTime(0);
                this.ref.nativeElement.src = this.vgHls;
            }
        }
    }

    getBwEstimator() {
        if (this.hls) {
            const bwEstimator = this.hls.abrController._bwEstimator;
            return bwEstimator ?
                bwEstimator.getEstimate() === 500000 ? NaN
                    : Math.round(bwEstimator.getEstimate() / 100000) / 10 : NaN;
        }
        return NaN;
    }

    setBitrate(bitrate: BitrateOption) {
        //console.log('setBitrate::::', bitrate)
        if (this.hls) {
            if (!!this.hls.levels
                && this.hls.levels.length > bitrate.qualityIndex)
                this.hls.nextLevel = bitrate.qualityIndex;
        }

    }

    destroyPlayer() {
        console.debug("hls destory")
        if (this.hls) {
            this.hls.destroy();
            this.hls = null;
            this.API.ss = null;
        }
    }
    private isDestorying =false;
    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        this.destroyPlayer();
        this.isDestorying = true;
       // console.log("vg-hls destory")
    }
}
